import { Box, Typography, List, ListItem } from '@mui/material'
import React from 'react'
import { CommonTable } from '../common'

// Table columns configuration
const columns = [
  {
    id: 'cookiesName',
    label: 'Name',
    width: '150px',
  },
  {
    id: 'cookiesPurpose',
    label: 'Purpose',
    width: '200px',
  },
  {
    id: 'cookiesType',
    label: 'Type',
    width: '150px',
  },
]

const CookiePolicy = () => {
  const mockEntities = [
    {
      id: 1,
      cookiesName: 'refresh_token',
      cookiesPurpose:
        'The token is generated after user id and password verification and this is being used for generating the access token after expiration. The validity of this token is 15 min',
      cookiesType: 'Session',
    },
    {
      id: 2,
      cookiesName: 'access_token',
      cookiesPurpose:
        'The token which is generated after user id and password match and the same. The validity of this token is 15 min',
      cookiesType: 'Session',
    },
  ]
  return (
    <Box className="font-normal text-base leading-5">
      <Typography variant="p" className="text-sm leading-5">
        Cookies are small text files that are placed on your computer by the
        websites that you visit. They are widely used in order to make websites
        work, or work more efficiently, as well as to provide information to the
        owners of the site. The use of cookies is now standard for most
        websites. If you are uncomfortable with the use of cookies, you can
        manage and control them through your browser, including removing cookies
        by deleting them from your ‘browser history’ (cache) when you leave the
        site.
      </Typography>
      <Box className="py-2.5 text-sm leading-normal ">Types of cookies:</Box>
      <List className="space-y-2 text-sm leading-normal  list-inside list-disc">
        <ListItem
          sx={{
            display: 'list-item',
            listStyleType: 'disc',
            listStylePosition: 'inside',
          }}
        >
          Session' cookies remain in your browser during your browser session
          only, i.e. until you leave the website.
        </ListItem>
        <ListItem
          sx={{
            display: 'list-item',
            listStyleType: 'disc',
            listStylePosition: 'inside',
          }}
        >
          'Persistent' cookies remain in your browser after the session, unless
          you delete them.
        </ListItem>
        <ListItem
          sx={{
            display: 'list-item',
            listStyleType: 'disc',
            listStylePosition: 'inside',
          }}
        >
          'Performance' cookies collect information about your use of the
          website, such as webpages visited and any error messages; they do not
          collect personally identifiable information, and the information
          collected is aggregated such that it is anonymous. Performance cookies
          are used to improve how a website works.
        </ListItem>
        <ListItem
          sx={{
            display: 'list-item',
            listStyleType: 'disc',
            listStylePosition: 'inside',
          }}
        >
          'Functionality' cookies allow the website to remember any choices you
          make about the website (such as changes to text size, customised
          pages) or enable services such as commenting on a blog.
        </ListItem>
      </List>
      <Box className="pt-2.5 text-sm leading-normal ">
        Use of cookies by PwC:
      </Box>
      <Box className="pb-2.5 text-sm leading-normal">
        The following table explains the way in which we use cookies on this
        website.
      </Box>

      <Box>
        <CommonTable
          columns={columns}
          data={mockEntities}
          loading={false}
          onDelete={{}}
          showActions={false}
        />
      </Box>
    </Box>
  )
}

export default CookiePolicy
